import * as PolicyActionTypes from '../actions/policy';
import history from '../utils/history';
import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state = initialState.quote, action) => {
  const { payload, type } = action;

  switch (type) {
    case PolicyActionTypes.LIST_CONVEYANCE:
    case PolicyActionTypes.LIST_CONVEYANCE_PENDING:
      return { ...state };

    case PolicyActionTypes.LIST_CONVEYANCE_REJECTED:
      return {
        ...state,
        error: true,
        ...errorResponseHandler(payload, 'ConveyanceList')
      };

    case PolicyActionTypes.LIST_CONVEYANCE_FULFILLED:
      return { ...state, error: false, conveyances: payload.data };

    case PolicyActionTypes.LIST_COUNTRIES:
    case PolicyActionTypes.LIST_COUNTRIES_PENDING:
      return { ...state };

    case PolicyActionTypes.LIST_COUNTRIES_REJECTED:
      return {
        ...state,
        error: false,
        ...errorResponseHandler(payload, 'CountriesList')
      };

    case PolicyActionTypes.LIST_COUNTRIES_FULFILLED:
      return { ...state, countries: payload.data, error: false };

    case PolicyActionTypes.LIST_CURRENCIES:
    case PolicyActionTypes.LIST_CURRENCIES_PENDING:
      return { ...state };

    case PolicyActionTypes.LIST_CURRENCIES_REJECTED:
      return {
        ...state,
        error: true,
        ...errorResponseHandler(payload, 'CurrenciesList')
      };

    case PolicyActionTypes.LIST_CURRENCIES_FULFILLED:
      return { ...state, error: false, currencies: payload.data };

    case PolicyActionTypes.LIST_DESTINATION_TOWNS:
    case PolicyActionTypes.LIST_DESTINATION_TOWNS_PENDING:
      return { ...state, destinationTownsLoading: true };

    case PolicyActionTypes.LIST_DESTINATION_TOWNS_REJECTED:
      return {
        ...state,
        destinationTownsLoading: false,
        ...errorResponseHandler(payload, 'PortsList')
      };

    case PolicyActionTypes.LIST_DESTINATION_TOWNS_FULFILLED:
      return {
        ...state,
        destinationTownsLoading: false,
        destinationTowns: payload.data
      };

    case PolicyActionTypes.LIST_DESTINATION_PORTS:
    case PolicyActionTypes.LIST_DESTINATION_PORTS_PENDING:
      return { ...state, destinationPortsLoading: true };

    case PolicyActionTypes.LIST_DESTINATION_PORTS_REJECTED:
      return {
        ...state,
        destinationPortsLoading: false,
        ...errorResponseHandler(payload, 'PortsList')
      };

    case PolicyActionTypes.LIST_DESTINATION_PORTS_FULFILLED:
      return {
        ...state,
        destinationPortsLoading: false,
        destinationPorts: payload.data
      };

    case PolicyActionTypes.LIST_GOODS_SECTIONS:
    case PolicyActionTypes.LIST_GOODS_SECTIONS_PENDING:
      return { ...state, goodsSectionsLoading: true };

    case PolicyActionTypes.LIST_GOODS_SECTIONS_REJECTED:
      return {
        ...state,
        goodsSectionsLoading: false,
        ...errorResponseHandler(payload, 'GoodsSectionsList')
      };

    case PolicyActionTypes.LIST_GOODS_SECTIONS_FULFILLED:
      return { ...state, error: false, goodsSections: payload.data };

    case PolicyActionTypes.LIST_GOODS:
    case PolicyActionTypes.LIST_GOODS_PENDING:
      return { ...state, goodsLoading: true };

    case PolicyActionTypes.LIST_GOODS_REJECTED:
      return {
        ...state,
        goodsLoading: false,
        ...errorResponseHandler(payload, 'GoodsList')
      };

    case PolicyActionTypes.LIST_GOODS_FULFILLED:
      return { ...state, goodsLoading: false, goods: payload.data };

    case PolicyActionTypes.CREATE_QUOTE:
    case PolicyActionTypes.CREATE_QUOTE_PENDING:
      return { ...state, createQuoteLoading: true };

    case PolicyActionTypes.CREATE_QUOTE_REJECTED:
      return {
        ...state,
        createQuoteLoading: false,
        ...errorResponseHandler(payload, 'CreateQuote')
      };

    case PolicyActionTypes.CREATE_QUOTE_FULFILLED:
      history.push('/buy/buyer-details');
      sessionStorage.setItem('quote', JSON.stringify(payload.data));
      return {
        ...state,
        createQuoteLoading: false,
        error: false,
        success: true,
        quote: payload.data
      };

    case PolicyActionTypes.UPDATE_QUOTE:
    case PolicyActionTypes.UPDATE_QUOTE_PENDING:
      return { ...state, updateQuoteLoading: true };

    case PolicyActionTypes.UPDATE_QUOTE_REJECTED:
      return {
        ...state,
        updateQuoteLoading: false,
        ...errorResponseHandler(payload, 'UpdateQuote')
      };

    case PolicyActionTypes.UPDATE_QUOTE_FUFLILLED:
      sessionStorage.removeItem('quote');
      sessionStorage.setItem('quote', JSON.stringify(payload.data));
      return {
        ...state,
        updateQuoteLoading: false,
        error: false,
        success: 'Policy updated successfully'
      };

    case PolicyActionTypes.UPLOAD_DOCUMENT:
    case PolicyActionTypes.UPLOAD_DOCUMENT_PENDING:
      return { ...state };

    case PolicyActionTypes.UPLOAD_DOCUMENT_FILFILLED:
      sessionStorage.setItem('documents', JSON.stringify(payload.data));
      return {
        ...state,
        documents: payload.data,
        uploaded: payload.request.status === 201 ? true : false
      };

    case PolicyActionTypes.UPLOAD_DOCUMENT_REJECTED:
      return { ...state, error: true, errorMessage: payload.response.data };

    case PolicyActionTypes.EMAIL_QUOTE:
    case PolicyActionTypes.EMAIL_QUOTE_PENDING:
      return { ...state };

    case PolicyActionTypes.EMAIL_QUOTE_REJECTED:
      return {
        ...state,
        emailError: true,
        errorMessage: payload.response.data
      };

    case PolicyActionTypes.EMAIL_QUOTE_FULFILLED:
      return { ...state, emailSent: true, message: 'Email Sent Successfully' };

    case PolicyActionTypes.EMAIL_CERTIFICATE:
    case PolicyActionTypes.EMAIL_CERTIFICATE_PENDING:
      return { ...state };

    case PolicyActionTypes.EMAIL_CERTIFICATE_REJECTED:
      return { ...state, emailError: true, errorMessage: payload.response };

    case PolicyActionTypes.EMAIL_CERTIFICATE_FULFILLED:
      return {
        ...state,
        emailSent: true,
        message: 'Certificate emailed Successfully'
      };

    // POLICY VERIFICATION BY THE PUBLIC
    case PolicyActionTypes.VERIFY_POLICY:
      return { ...state };
    case PolicyActionTypes.VERIFY_POLICY_PENDING:
      return { ...state };
    case PolicyActionTypes.VERIFY_POLICY_REJECTED:
      return {
        ...state,
        verifyError: true,
        errorMessage: payload.response.data.Error
      };
    case PolicyActionTypes.VERIFY_POLICY_FULFILLED:
      return { ...state, verifySuccess: true, verifiedPolicy: payload.data };

    case PolicyActionTypes.REQUEST_SELCOM:
    case PolicyActionTypes.REQUEST_SELCOM_PENDING:
      return { ...state, selcomPaymentPending: true };

    case PolicyActionTypes.REQUEST_SELCOM_REJECTED:
      return {
        ...state,
        selcomPaymentPending: false,
        error: true,
        ...errorResponseHandler(payload, 'RequestSelcom')
      };

    case PolicyActionTypes.REQUEST_SELCOM_FULFILLED:
      return {
        ...state,
        selcomPaymentPending: false,
        error: false,
        success: true,
        selcomMessage: payload.data
      };

    case PolicyActionTypes.CHECK_PAYMENT_STATUS:
    case PolicyActionTypes.CHECK_PAYMENT_STATUS_PENDING:
      return { ...state, checkPaymentStatusPending: true };
    case PolicyActionTypes.CHECK_PAYMENT_STATUS_REJECTED:
      return {
        ...state,
        checkPaymentStatusPending: false,
        error: true,
        ...errorResponseHandler(payload, 'CheckPaymentStatus')
      };
    case PolicyActionTypes.CHECK_PAYMENT_STATUS_FULFILLED:
      //const newQuote=this.payload.data;
      return {
        ...state,
        quote: payload.data,
        error: false,
        is_paid: payload.data.is_paid,
        success: true,
        checkPaymentStatusPending: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/policy.js